import { useEffect, useState } from 'react';
import { useStripe } from '@stripe/react-stripe-js';

import ToastNotification from '../ToastNotification';

export default function CheckPaymentMethodStatus() {
  const stripe = useStripe();
  const [statusMessage, setStatusMessage] = useState();

  useEffect(() => {
    if (statusMessage) {
      setTimeout(() => setStatusMessage(null), 10000);
    }
  }, [statusMessage]);

  useEffect(() => {
    if (!stripe) {
      return;
    }

    const clientSecret = new URLSearchParams(window.location.search).get(
      'setup_intent_client_secret'
    );

    if (!clientSecret) {
      return;
    }

    stripe.retrieveSetupIntent(clientSecret).then(({ setupIntent }) => {
      switch (setupIntent.status) {
        case 'succeeded':
          setStatusMessage('Success! Your payment method has been saved.');
          break;

        case 'processing':
          setStatusMessage(
            "Processing payment details. We'll update you when processing is complete."
          );
          break;

        case 'requires_payment_method':
          setStatusMessage(
            'Failed to process payment details. Please try another payment method.'
          );
          break;

        default:
          break;
      }
    });
  }, [stripe]);

  if (!statusMessage) return null;

  return (
    <ToastNotification
      message={statusMessage}
      success={true}
      show={statusMessage}
    />
  );
}
